import { Fragment } from 'react'
import {
  List,
  Datagrid,
  TextField,
  DateField,
  EditButton,
  ReferenceField,
  DeleteButton,
  ReferenceInput,
  SelectInput,
  TextInput,
  TopToolbar,
  CreateButton,
  ExportButton,
  useRecordContext,
  usePermissions,
  FunctionField,
} from 'react-admin'

import CourseActionButton from '../../components/CourseActionButton'
import CourseStatusField from '../../components/CourseStatusField'
import FilterComponent from '../../components/Filter'
import { ROLES } from '../../components/constants'

const Actions = props => {
  const { resource, currentSort, filterValues, exporter, basePath } = props
  return (
    <TopToolbar>
      <CreateButton basePath={basePath} />
      <ExportButton
        disabled={false}
        resource={resource}
        sort={currentSort}
        filter={filterValues}
        exporter={exporter}
        maxResults={10000}
      />
    </TopToolbar>
  )
}

const CourseFilter = props => (
  <FilterComponent {...props}>
    <TextInput label="Search by title" source="title" alwaysOn />
    <ReferenceInput
      label="Publisher"
      source="publisherId"
      reference="users"
      filter={{ role: 'publisher' }}
      alwaysOn>
      <SelectInput
        optionText="name"
        options={{
          fullWidth: true,
        }}
      />
    </ReferenceInput>
  </FilterComponent>
)

const ActionField = () => {
  const { permissions } = usePermissions()
  const record = useRecordContext()
  if (!record || permissions !== ROLES.ADMIN) return null

  switch (record.status) {
    case 'Under review':
      return (
        <Fragment>
          <CourseActionButton
            label="Approve"
            action="approve"
            color="primary"
            record={record}
          />
          <CourseActionButton
            label="Reject"
            action="reject"
            color="secondary"
            record={record}
          />
        </Fragment>
      )

    default:
      return <DeleteButton label="Delete" record={record} undoable={false} />
  }
}

const CourseList = () => {
  const { permissions } = usePermissions()

  return (
    <List
      filters={<CourseFilter />}
      actions={<Actions />}
      sort={{ field: 'updatedAt', order: 'DESC' }}
      bulkActionButtons={false}>
      <Datagrid bulkActionButtons={false} rowClick={false}>
        <TextField source="id" />
        <TextField source="title" />
        <FunctionField
          label="Mentors"
          render={record =>
            record && record.mentors?.map(mentor => mentor.name).join(', ')
          }
        />
        <ReferenceField
          source="publisherId"
          reference="users"
          label="Publisher">
          <TextField source="name" />
        </ReferenceField>
        <DateField source="datePublished" label="Publish Date" />
        <ReferenceField label="Created by" source="createdBy" reference="users">
          <TextField source="name" />
        </ReferenceField>
        <ReferenceField label="Updated by" source="updatedBy" reference="users">
          <TextField source="name" />
        </ReferenceField>
        <DateField source="createdAt" />
        <DateField source="updatedAt" />
        <CourseStatusField disabled={permissions !== ROLES.ADMIN} />
        <EditButton />
        <ActionField permissions={permissions} />
      </Datagrid>
    </List>
  )
}

export default CourseList
